import './style.scss';
import { Media } from '../../../js/utils/const';
import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate'
import { Timer } from '../../../js/components/Timer/Timer';
import { CartModal } from '../../../js/components/CartModal/scripts';

export default !function () {
  const block = document.querySelector('.tariffs-v3');

  if (!block) {
    return;
  }

  const blockName = block.dataset?.blockName || 'Блок без названия'
  const xl = window.matchMedia(`(min-width: ${Media.XL}px)`);
  // init timers
  const timers = block.querySelectorAll('.tariffs-v3__sale-item--timer');

  timers.forEach((timerWrapper) => {
    saleEndDate
      .addObserver(time => new Timer({ time, timerWrapper }))
  });

  const titles = block.querySelectorAll('.tariffs-v3__subtitle');
  const programs = block.querySelectorAll('.tariffs-v3__program');
  const footers = block.querySelectorAll('.tariffs-v3__bottom');

  const setHeight = (elements) => {
    const heights = [...elements].map((p) => p.clientHeight);

    elements.forEach((el) => {
      el.style.height = `${Math.max(...heights)}px`;
    });
  }

  const removeStyle = (elements) => {
    elements.forEach(p => p.removeAttribute('style'));
  }

  if (xl.matches) {
    setHeight(titles);
    setHeight(programs);
    setHeight(footers);
  }

  xl.addEventListener('change', (evt) => {
    if (evt.matches) {
      setHeight(titles);
      setHeight(programs);
      setHeight(footers)
    } else {
      removeStyle(titles);
      removeStyle(programs);
      removeStyle(footers);
    }
  });

  block.addEventListener('click', (evt) => {
    const card = evt.target.closest('.tariffs-v3__item');

    if (!card) {
      return;
    }

    const data = JSON.parse(card.dataset.tariffData);
    const button = evt.target.closest('.tariffs-v3__button');

    if (button) {
      /* eslint-disable-next-line */
      !isGbHost && window.$analytics?.push('fl-show-form');

      window.$analytics?.push('tariff-subscribe-button-click', {
        tariffName: data.name,
        blockName
      });

      new CartModal({ blockName, tariffData: data }).init();
    }
  });
}();
